// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3qNLU","name":"ConsentHeader_name__1gY-i","birthday":"ConsentHeader_birthday__3qgVf","skeleton":"ConsentHeader_skeleton__2ViPb"};